import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-white text-black shadow-xl rounded-xl p-6 max-w-xl w-[90%] z-50">
      
      <h3 className="text-lg font-semibold mb-2">
        Controle sua privacidade
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Utilizamos cookies para melhorar sua experiência e analisar o tráfego
        do site. Você pode aceitar todos, rejeitar ou gerenciar.
      </p>

      <div className="flex gap-3 justify-end">
        
        <button
          onClick={rejectCookies}
          className="border border-gray-300 px-4 py-2 rounded-lg text-sm hover:bg-gray-100"
        >
          Rejeitar
        </button>

        <button
          onClick={acceptCookies}
          className="bg-brand-sage text-brand-dark px-4 py-2 rounded-lg text-sm font-semibold shadow hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-brand-dark"
        >
          Aceitar
        </button>

      </div>
    </div>
  );
}